import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-component p-fluid p-formgrid p-grid" }
const _hoisted_2 = { class: "p-col-3" }
const _hoisted_3 = { style: {"font-size":"1rem"} }
const _hoisted_4 = { class: "p-field p-input-filled p-col-9" }
const _hoisted_5 = {
  key: 0,
  class: "p-error"
}
const _hoisted_6 = { class: "p-col-3" }
const _hoisted_7 = { style: {"font-size":"1rem"} }
const _hoisted_8 = { class: "p-field p-input-filled p-col-9" }
const _hoisted_9 = { class: "p-col-3" }
const _hoisted_10 = { style: {"font-size":"1rem"} }
const _hoisted_11 = { class: "p-col-9" }
const _hoisted_12 = { class: "p-field p-input-filled p-inputgroup" }
const _hoisted_13 = { class: "p-col-3" }
const _hoisted_14 = { style: {"font-size":"1rem","cursor":"help"} }
const _hoisted_15 = { class: "p-col-9" }
const _hoisted_16 = { class: "p-field p-input-filled p-inputgroup" }
const _hoisted_17 = { class: "p-col-3" }
const _hoisted_18 = { style: {"font-size":"1rem","cursor":"help"} }
const _hoisted_19 = { class: "p-field p-input-filled p-col-9" }
const _hoisted_20 = { class: "p-col-3" }
const _hoisted_21 = { style: {"font-size":"1rem"} }
const _hoisted_22 = { class: "p-field p-input-filled p-col-9" }
const _hoisted_23 = { class: "p-inputgroup" }
const _hoisted_24 = {
  key: 1,
  class: "p-inputtext p-component region-display region-display--unset"
}
const _hoisted_25 = { class: "p-col-3" }
const _hoisted_26 = { style: {"font-size":"1rem"} }
const _hoisted_27 = { class: "p-field p-input-filled p-col-9" }
const _hoisted_28 = { class: "p-col-3" }
const _hoisted_29 = { class: "inner-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_FormPositionTrainingTable = _resolveComponent("FormPositionTrainingTable")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.trainingKey.description), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_InputText, {
          type: "text",
          modelValue: _ctx.trainingKey.value.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.trainingKey.value.value) = $event)),
          disabled: ""
        }, null, 8, ["modelValue"]),
        (!(_ctx.trainingKey.value.value !== '' && _ctx.trainingKey.value.value !== null))
          ? (_openBlock(), _createElementBlock("small", _hoisted_5, _toDisplayString(_ctx.$t("Squeeze.Training.TrainingKey")), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("Squeeze.Training.Indicator")), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_Dropdown, {
          modelValue: _ctx.indicatorId,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.indicatorId) = $event)),
          options: _ctx.allIndicators,
          optionLabel: "description",
          optionValue: "id"
        }, null, 8, ["modelValue", "options"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t("Squeeze.Training.Description")), 1)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_InputText, {
            type: "text",
            modelValue: _ctx.regionAnchor.description,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.regionAnchor.description) = $event))
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_14, [
          _createTextVNode(_toDisplayString(_ctx.$t("Squeeze.Training.KeyWord")), 1)
        ])), [
          [
            _directive_tooltip,
            _ctx.regionAnchor.locatorId ? _ctx.$t('Squeeze.Training.OptionalFallback') : _ctx.$t('Squeeze.Training.Optional'),
            void 0,
            { top: true }
          ]
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_InputText, {
            type: "text",
            modelValue: _ctx.regionAnchor.keyWordPattern,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.regionAnchor.keyWordPattern) = $event)),
            placeholder: _ctx.$t('Squeeze.Training.KeyWord'),
            onFocus: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onFocusField('regionAnchorKeyWordPattern')))
          }, null, 8, ["modelValue", "placeholder"]),
          _createVNode(_component_Button, {
            class: "active",
            icon: "mdi mdi-auto-fix",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onFocusField('regionAnchorKeyWordPattern')))
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_18, [
          _createTextVNode(_toDisplayString(_ctx.$t("Squeeze.Training.Locator")), 1)
        ])), [
          [
            _directive_tooltip,
            _ctx.$t('Squeeze.Training.Optional'),
            void 0,
            { top: true }
          ]
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createVNode(_component_Dropdown, {
          modelValue: _ctx.regionAnchor.locatorId,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.regionAnchor.locatorId) = $event)),
          options: _ctx.allLocators,
          optionLabel: "description",
          optionValue: "id",
          showClear: true,
          placeholder: _ctx.$t('Squeeze.Training.SelectLocator')
        }, null, 8, ["modelValue", "options", "placeholder"])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.$t("Squeeze.Training.Region")), 1)
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          (_ctx.regionBadge)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "p-inputtext p-component region-display region-display--set region-display--clickable",
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.markCurrentRegion && _ctx.markCurrentRegion(...args)))
              }, "✓ " + _toDisplayString(_ctx.regionBadge), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_ctx.$t('Squeeze.Training.RegionNotSet')), 1)),
          _createVNode(_component_Button, {
            icon: "mdi mdi-vector-rectangle",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onFocusField('regionAnchorRegion')))
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("p", _hoisted_26, _toDisplayString(_ctx.$t("Squeeze.Training.IgnoreSpaces")), 1)
      ]),
      _createElementVNode("div", _hoisted_27, [
        _createVNode(_component_Dropdown, {
          modelValue: _ctx.regionAnchor.ignoreWhiteSpaces,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.regionAnchor.ignoreWhiteSpaces) = $event)),
          options: _ctx.booleanOptions,
          optionLabel: "name",
          optionValue: "id"
        }, null, 8, ["modelValue", "options"])
      ]),
      _createElementVNode("div", _hoisted_28, [
        _withDirectives((_openBlock(), _createElementBlock("span", null, [
          _createVNode(_component_Button, {
            label: _ctx.regionAnchor.id ? _ctx.$t('Squeeze.Training.Retrain') : _ctx.$t('Squeeze.Training.Train'),
            disabled: !_ctx.canTrain,
            onClick: _ctx.trainRegionAnchor
          }, null, 8, ["label", "disabled", "onClick"])
        ])), [
          [
            _directive_tooltip,
            !_ctx.canTrain ? _ctx.$t('Squeeze.Training.PatternOrLocatorRequired') : null,
            void 0,
            { top: true }
          ]
        ])
      ])
    ]),
    _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1)),
    _createElementVNode("div", _hoisted_29, [
      _createVNode(_component_FormPositionTrainingTable, {
        tableOrigin: "regionAnchors",
        tableData: _ctx.allRegionAnchors,
        loading: _ctx.loading,
        onTestData: _ctx.testRegionAnchor,
        onChangeData: _ctx.changeRegionAnchor,
        onDeleteData: _ctx.deleteRegionAnchor,
        onOnMarkRegion: _ctx.onMarkRegion
      }, null, 8, ["tableData", "loading", "onTestData", "onChangeData", "onDeleteData", "onOnMarkRegion"])
    ])
  ], 64))
}